import { render, staticRenderFns } from "./ResultsReadyPageContent.vue?vue&type=template&id=52cdbb35&scoped=true"
import script from "./ResultsReadyPageContent.vue?vue&type=script&lang=ts"
export * from "./ResultsReadyPageContent.vue?vue&type=script&lang=ts"
import style0 from "./ResultsReadyPageContent.vue?vue&type=style&index=0&id=52cdbb35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdbb35",
  null
  
)

export default component.exports